import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import StepImage from './StepImage';

export const ChargerModelStepImage = (): JSX.Element => {
  const { product } = useWizardStateContext();

  const styleStep = product?.wizard?.styleStep;
  const image = styleStep?.image;

  return <StepImage image={image} />;
};

export default ChargerModelStepImage;
